import { loadCldr, L10n, setCulture } from "@syncfusion/ej2-base";

// Dados CLDR manuais
import numberingSystems from "./cldr/numberingSystems.json";
import gregorian from "./cldr/ca-gregorian.json";
import numbers from "./cldr/numbers.json";
import timeZoneNames from "./cldr/timeZoneNames.json";
import dateFields from "./cldr/dateFields.json";
import likelySubtags from "./cldr/likelySubtags.json";

// Seus textos personalizados (o JSON que você já tinha)
import ptBR from "./locales/locale-ptBR-syncfusion.json";

// Carregamento
loadCldr(
  numberingSystems,
  gregorian,
  numbers,
  timeZoneNames,
  dateFields,
  likelySubtags
);

L10n.load(ptBR);
setCulture("pt");
